import { InputHTMLAttributes, forwardRef } from "react";
import { cx } from "./classNames.js";

export interface TextInputProps extends InputHTMLAttributes<HTMLInputElement> {
  readonly hasError?: boolean;
}

/**
 * Text input — DESIGN-SYSTEM.md §6 (rounded-lg, arch-500 focus ring). `hasError`
 * swaps the border + ring to red; pair with {@link Field} for label + inline error.
 */
export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  function TextInput({ hasError = false, className, ...rest }, ref) {
    return (
      <input
        ref={ref}
        className={cx(
          "block w-full rounded-lg border px-3 py-2 text-sm bg-slate-800/60 text-slate-100",
          "placeholder:text-slate-500 transition-colors",
          "focus:outline-none focus:ring-2",
          hasError
            ? "border-red-500/70 focus:border-red-500 focus:ring-red-500/25"
            : "border-slate-700 focus:border-arch-500 focus:ring-arch-500/25",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        {...rest}
      />
    );
  },
);
